export const brandCategoryInitailColumnsBrandForm = [
    { id: 'brand', label: 'Brand', minWidth: 200, group: "brand_category" },
    { id: 'brand_key', label: 'Brand Key', minWidth: 200, group: "brand_category" },
    { id: 'summarized_brand', label: 'Summarized Brand', minWidth: 200, group: "brand_category" },
    {
        id: 'category_brand_key',
        label: 'Category Brand Key',
        minWidth: 200,
        align: 'right',
        group: "brand_category"
    },
    {
        id: 'category_sap',
        label: 'Category SAP',
        minWidth: 200,
        align: 'right',
        group: "brand_category"
    },
    {
        id: 'category',
        label: 'Category',
        minWidth: 150,
        align: 'right',
        group: "brand_category"
    },
    {
        id: 'brand_group',
        label: 'Brand Group',
        minWidth: 200,
        align: 'right',
        group: "brand_category"
    },
    {
        id: 'vending_category',
        label: 'Vending Category',
        minWidth: 150,
        align: 'right',
        group: "brand_category"
    },
    {
        id: 'brand_group_l2',
        label: 'Brand Grp L2',
        minWidth: 200,
        align: 'right',
        group: "brand_category"
    },
    {
        id: 'brand_ranking',
        label: 'Brand Ranking',
        minWidth: 130,
        align: 'right',
        group: "brand_category"
    },
    {
        id: 'category_ranking',
        label: 'Category Ranking',
        minWidth: 130,
        align: 'right',
        group: "brand_category"
    },
    {
        id: 'trv_l2',
        label: 'TRV L2',
        minWidth: 150,
        align: 'right',
        group: "trv"
    },
    {
        id: 'trv_l3',
        label: 'TRV L3',
        minWidth: 150,
        align: 'right',
        group: "trv"
    },
    {
        id: 'trv_l4',
        label: 'TRV L4',
        minWidth: 150,
        align: 'right',
        group: "trv"
    },
    {
        id: 'trv_l5',
        label: 'TRV L5',
        minWidth: 150,
        align: 'right',
        group: "trv"
    },
    {
        id: 'trv_l6',
        label: 'TRV L6',
        minWidth: 150,
        align: 'right',
        group: "trv"
    },
    {
        id: 'trv_l7',
        label: 'TRV L7',
        minWidth: 200,
        align: 'right',
        group: "trv"
    },
    {
        id: 'trv_l3_ranking',
        label: 'TRV L3 Ranking',
        minWidth: 130,
        align: 'right',
        group: "trv"
    },
    {
        id: 'trv_l4_ranking',
        label: 'TRV L4 Ranking',
        minWidth: 130,
        align: 'right',
        group: "trv"
    },
    {
        id: 'trv_l5_ranking',
        label: 'TRV L5 Ranking',
        minWidth: 130,
        align: 'right',
        group: "trv"
    },
    {
        id: 'trv_l6_ranking',
        label: 'TRV L6 Ranking',
        minWidth: 130,
        align: 'right',
        group: "trv"
    },
    {
        id: 'trv_l7_ranking',
        label: 'TRV L7 Ranking',
        minWidth: 130,
        align: 'right',
        group: "trv"
    },
    {
        id: 'innovation',
        label: 'Innovation',
        minWidth: 50,
        align: 'right',
        group: "trv"
    },
    {
        id: 'tccc_indicator_sap',
        label: 'TCCC Indicator SAP',
        minWidth: 150,
        align: 'right',
        group: "dmi"
    },
    {
        id: 'sum_brand_ko',
        label: 'Sum brand KO',
        minWidth: 200,
        align: 'right',
        group: "dmi"
    },
    {
        id: 'category_vr',
        label: 'Category VR',
        minWidth: 150,
        align: 'right',
        group: "dmi"
    },
    {
        id: 'added_by',
        label: 'Added By',
        minWidth: 235,
        align: 'right',
        group: "other"
    },
    {
        id: 'updated_by',
        label: 'Updated By',
        minWidth: 235,
        align: 'right',
        group: "other"
    },
    {
        id: 'updated_at',
        label: 'Updated At',
        minWidth: 235,
        align: 'right',
        group: "other"
    },
    {
        id: 'action',
        label: '',
        minWidth: 50,
        align: 'right',
        group: "other"
    },
];